// extracted by mini-css-extract-plugin
export default {"container":"document_form_money_container__2cykI","input":"document_form_money_input__w1ea4","tooltip":"document_form_money_tooltip__PIvOo"};